// extracted by mini-css-extract-plugin
export var avatarContainer = "_gw-0";
export var avatarTypingWave = "_gw-i";
export var gray = "_gw-f";
export var green = "_gw-c";
export var icon = "_gw-9";
export var image = "_gw-1";
export var lg = "_gw-6";
export var md = "_gw-5";
export var presenceDot = "_gw-b";
export var red = "_gw-d";
export var sm = "_gw-4";
export var status = "_gw-a";
export var typingDot = "_gw-h";
export var typingPill = "_gw-g";
export var xl = "_gw-7";
export var xs = "_gw-3";
export var xxl = "_gw-8";
export var xxs = "_gw-2";
export var yellow = "_gw-e";